import type { FaireProductEntity } from "../../entity_types/product";

export const p_y6gyryaxdg: FaireProductEntity = {
  token: "p_y6gyryaxdg",
  type: "product",
  name: "Waffle Knit Crop Pullover & Leggings Set",
  brandToken: "b_bikrbjnoof",
  brandName: "Listicle",
  imageUrl: "https://cdn.faire.com/fastly/95cfbca9ad77d0d60cb5bd7ca6dd200bd96242fc21f67d4fed53aa1dc7a59299.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/1f7c32622925b6713f8984007c33fd2e2543167f4be7d67a90c45f49f3aab5d4.jpeg",
    "https://cdn.faire.com/fastly/d1bdc899d6d2a619e7d3b2b8b95aba1725140eb73dd71dbbb8dd824362f2e31c.jpeg",
    "https://cdn.faire.com/fastly/afb1fdeb47fbe94bd6f1fd655986f07ecd12d6e0f0b77c635685d1ed6d082ea4.jpeg",
    "https://cdn.faire.com/fastly/639ecd13f6ffc8c04475b3c550621186c83dacd52213c0afa7023c6cdf0314fb.jpeg",
    "https://cdn.faire.com/fastly/d43739c485c0acb75f03931991ac40e51795abab2eeae08c36d2369c0751836c.jpeg",
    "https://cdn.faire.com/fastly/2c4b7ce79cde534473617f335c432441f4efa00078564af0086c72252a77815f.jpeg",
    "https://cdn.faire.com/fastly/a5f3fae025165b75e1e60e4d5751e0df745213681e6606aeefa2b14264844120.jpeg",
    "https://cdn.faire.com/fastly/0cb702274c8510aeaea23357d3c8367784e3bda536c193d2925bc6c8b5890c78.jpeg",
    "https://cdn.faire.com/fastly/0bfca10febe0adc45384e83d83f67ade7199a95f92cab72fa809a1378353910b.jpeg",
    "https://cdn.faire.com/fastly/3417d8d11b61aed539af680391e33fbd9d38e0fac95426afb5b07a1f8d6b68ec.jpeg",
    "https://cdn.faire.com/fastly/46b0940a80361e3e7e790b7fd81a5547cfe3d1f4e0d312af277e4df1414ad1a8.jpeg",
    "https://cdn.faire.com/fastly/e7ef9ce2eabc860cf596601f0f73904194a6035b9a7dac7d002747957dafcce0.jpeg",
    "https://cdn.faire.com/fastly/c029f474ca30ecae96048aa0d36dcfc9da91c684fa26a733a89c7421517cde8e.jpeg",
    "https://cdn.faire.com/fastly/a487f048f8264d75c82e5a46d6973f4d1dce9a25861d6612ec98c2ff7175928d.jpeg",
    "https://cdn.faire.com/fastly/26ad7085233d6bf5694c83cfb2bbfb82e77187efa1f6759123f022d32d00fe75.jpeg",
    "https://cdn.faire.com/fastly/b07f66e7cdad75beca54e183c055d70e119469fa6d4f4c8d86891017d73c05d1.jpeg",
    "https://cdn.faire.com/fastly/7c3394e08dca02f4a3c68ecaccc2595bfd17736a878d9016d0a482f9d1b4d76f.jpeg",
    "https://cdn.faire.com/fastly/783314ba44eeb5c6129979ec30a4654a14dcac3f3727560f70312f6f61be30ed.jpeg",
    "https://cdn.faire.com/fastly/04dbd966a3563f7ef3f661b6cf0811eb9c94c1b181f12a29c3c83ae472076097.jpeg"
  ],
  priceDollars: 117,
  description: "- Top: Long-sleeve cropped pullover with relaxed drop shoulders and crew neckline\n- Bottoms: High-waisted full-length leggings with a flattering, form-fitting silhouette\n- Fabric: Soft waffle knit texture for cozy warmth and breathable comfort\n- Pockets: Leggings feature convenient side pockets for small essentials\n- Fit: Lightweight yet snug, perfect for loungewear, errands, or layering\n- Model is 5' 10\" 32-26-35 and wearing a size Small\n\nThis versatile set for women blends everyday ease with boutique comfort—style with socks, slippers, or graphic tees for the ultimate athleisure look all year long.\n",
  tags: [],
  msrpDollars: 234,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:55:19.880Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
